export default __webpack_public_path__ + "static/media/467.1bc9b0d2.png";